export default __webpack_public_path__ + "static/ti_hoverbike_block-b1735def575315d40266312cafb27065.svg";